<div class="premium-modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="close()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main">Seleccionar Trabajador</div>
          <div class="title-sub">Gestión de personal en obra</div>
        </div>
        <div class="icon-btn" style="visibility: hidden;">
          <ion-icon name="close"></ion-icon>
        </div>
      </div>
    </div>

  </ion-header>

  <ion-content class="content-bg" [fullscreen]="false">
    <div class="form-wrapper ion-padding">

      <!-- Search Bar -->
      <div class="search-wrapper" *ngIf="!isReviewMode">
        <ion-searchbar #searchBar [(ngModel)]="searchTerm" (ionInput)="filterWorkers()"
          placeholder="Buscar por nombre o alias" mode="ios"></ion-searchbar>
      </div>

      <div class="premium-card create-new-container" (click)="createNewWorker()" *ngIf="false">
        <div class="icon-circle">
          <ion-icon name="person-add-outline"></ion-icon>
        </div>
        <div class="text">
          <h3>Crear Nuevo Trabajador</h3>
          <p>Registrar una nueva persona</p>
        </div>
        <ion-icon name="chevron-forward-outline" class="arrow"></ion-icon>
      </div>

      <div class="list-header" *ngIf="!isReviewMode">
        <h3>Lista de Trabajadores</h3>
        <ion-note slot="end" *ngIf="selectedWorkers.size > 0" color="primary">
          {{ selectedWorkers.size }} seleccionados
        </ion-note>
      </div>

      <!-- SELECTION MODE -->
      <ion-list lines="none" style="background: transparent;" *ngIf="!isReviewMode">
        <ion-item *ngFor="let worker of displayedWorkers" (click)="toggleSelection(worker)" detail="false" button
          class="worker-item" [class.selected-item]="isSelected(worker)" [class.disabled]="isAlreadyAdded(worker.id)">
          <div slot="start" class="avatar-wrapper">
            <div class="worker-avatar" [class.avatar-selected]="isSelected(worker)">
              {{ isSelected(worker) ? '✓' : worker.nombre.charAt(0) }}
            </div>
          </div>
          <ion-label>
            <h2>{{ worker.nombre }}</h2>
            <p>{{ worker.alias ? worker.alias : 'Sin alias' }} • {{ worker.rol || 'General' }}</p>

            <div class="status-badge" *ngIf="isAlreadyAdded(worker.id)">
              <ion-icon name="checkmark-circle" style="vertical-align: middle; margin-right: 4px;"></ion-icon>
              <span style="font-size: 0.8rem; font-weight: 600; vertical-align: middle;">Agregado</span>
            </div>

          </ion-label>
          <div slot="end" class="selection-container">
            <div class="selection-circle" [class.selected]="isSelected(worker)"
              [class.disabled]="isAlreadyAdded(worker.id)">
              <ion-icon name="checkmark-sharp" *ngIf="isSelected(worker)"></ion-icon>
            </div>
          </div>
        </ion-item>

        <div class="empty-list" *ngIf="filteredWorkers.length === 0 && !loading">
          <p>No se encontraron trabajadores.</p>
        </div>
      </ion-list>

      <ion-infinite-scroll *ngIf="!isReviewMode" threshold="100px" (ionInfinite)="loadData($event)">
        <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Cargando más trabajadores...">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>


      <!-- REVIEW MODE -->
      <div class="review-container" *ngIf="isReviewMode">
        <div class="review-header">
          <h3>Resumen de Planilla</h3>
          <p>Verifique los montos y añada detalles</p>
        </div>

        <!-- Shift Control -->
        <div class="shift-control-card">
          <div class="shift-option" [class.active]="selectedShift === 'D'" (click)="updateShift('D')">
            <span class="icon">☀️</span>
            <span class="label">Diurno</span>
            <span class="price">${{ displayCostoDia }}</span>
          </div>
          <div class="shift-option night" [class.active]="selectedShift === 'N'" (click)="updateShift('N')">
            <span class="icon">🌙</span>
            <span class="label">Nocturno</span>
            <span class="price">${{ displayCostoNoche }}</span>
          </div>
        </div>

        <div class="review-list">
          <div *ngFor="let item of reviewList" class="form-card modern-card">
            <div class="card-indicator" [class.night]="item.turno === 'N'"></div>
            <div class="card-content-wrapper">

              <div class="card-top">
                <div class="worker-info">
                  <h4>{{ item.nombre }}</h4>
                  <span class="role-badge">{{ item.rol || 'Trabajador' }}</span>
                </div>
              </div>

              <div class="grid-inputs triple">
                <div class="input-group">
                  <label><ion-icon name="cash-outline"></ion-icon> Pago</label>
                  <div class="premium-input-wrapper">
                    <input type="number" [(ngModel)]="item.monto" placeholder="0">
                  </div>
                </div>

                <div class="input-group">
                  <label><ion-icon name="add-circle-outline"></ion-icon> Extra</label>
                  <div class="premium-input-wrapper positive">
                    <input type="number" [(ngModel)]="item.extra" placeholder="0">
                  </div>
                </div>

                <div class="input-group">
                  <label><ion-icon name="remove-circle-outline"></ion-icon> Descuento</label>
                  <div class="premium-input-wrapper negative">
                    <input type="number" [(ngModel)]="item.descuento" placeholder="0">
                  </div>
                </div>
              </div>

              <div class="input-group full">
                <label><ion-icon name="business-outline"></ion-icon> ¿Es Subcontrato?</label>
                <div class="radio-group-modern">
                  <div class="radio-box" [class.active]="!item.subcontrato" (click)="item.subcontrato = false">
                    <span>No</span>
                  </div>
                  <div class="radio-box active-val" [class.active]="item.subcontrato" (click)="item.subcontrato = true">
                    <span>Sí</span>
                  </div>
                </div>
              </div>

              <div class="input-group full">
                <label><ion-icon name="document-text-outline"></ion-icon> Nota / Comentario</label>
                <div class="premium-input-wrapper">
                  <input type="text" [(ngModel)]="item.nota" placeholder="Opcional...">
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </ion-content>

  <div class="form-footer-actions" *ngIf="!isReviewMode && selectedWorkers.size > 0">
    <ion-button *ngIf="mode === 'planilla'" expand="block" class="save-btn" (click)="startReview()">
      <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
      Continuar ({{ selectedWorkers.size }})
    </ion-button>
    <ion-button *ngIf="mode === 'select'" expand="block" class="save-btn" (click)="confirmSelection()">
      <ion-icon name="checkmark-done-outline" slot="start"></ion-icon>
      Seleccionar ({{ selectedWorkers.size }})
    </ion-button>
  </div>

  <div class="form-footer-actions" *ngIf="isReviewMode">
    <ion-button fill="outline" class="cancel-modal-btn" (click)="cancelReview()">
      <ion-icon name="arrow-back-outline" slot="start"></ion-icon>
      Atrás
    </ion-button>
    <ion-button class="save-btn" (click)="saveBatch()">
      <ion-icon name="checkmark-done-outline" slot="start"></ion-icon>
      Finalizar
    </ion-button>
  </div>
</div>